












import Vue from 'vue';
import { mapActions } from 'vuex';

import Import from './Import.vue';

export default Vue.extend({
  name: 'ImportPage',
  components: {
    Import,
  },
  created() {
    this.setPageTitle({ title: 'Data Import' });
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
      showAlert: 'alerts/show',
    }),
    imported() {
      this.showAlert({
        type: 'success',
        message: 'File imported successfully.',
      });
    },
  },
});
